import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-image-to-pdf',
    imports: [],
    templateUrl: './blog-image-to-pdf.component.html',
    styleUrl: './blog-image-to-pdf.component.css'
})
export class BlogImageToPdfComponent {

}
